import { useTranslation } from 'react-i18next';

import { Anchor } from '@klv/atoms/anchor';
import Typography from '@klv/atoms/typography';
import { generateClassName } from '@klv/shared/utils/functions';

import * as styles from './styles/tableOfContents.module.scss';

import type { ITableOfContents } from './types';

export const TableOfContents = ({ className, currentSection, headingTag = 'div', sections, ...rest }: ITableOfContents) => {
  const { t } = useTranslation();

  return (
    <nav className={generateClassName([className, styles.tableOfContents])} {...rest}>
      <Typography className={styles.heading} forwardedAs={headingTag} variant="h6Semibold">{t('organisms_articleTableContents_tableContents')}</Typography>
      <ul className={styles.sectionLinkList}>
        {sections.map((section, index) => (
          <li className={generateClassName(['linkListItem', styles.linkListItem])} key={section.id}>
            <Anchor
              aria-current={currentSection ? (currentSection === section.id) : (index === 0)}
              className={generateClassName(['sectionLink', styles.sectionLink])}
              to={`#${section.id}`}
            >
              <Typography
                className={styles.sectionName}
                variant='paragraph1'
              >
                {section.name}
              </Typography>
            </Anchor>
          </li>
        ))}
      </ul>
    </nav>
  );
};
